import { CircularProgress, Button as MuiButton, SxProps, TextField, Typography, styled } from "@mui/material";
import React, { FC } from "react";
import { FacebookOauthButton } from "../common/FacebookOauthButton";
import { FormComponent } from "../common/Form";
import { GoogleOauthButton } from "../common/GoogleOauthButton";
import { EditorButtonType } from "./KeyEditorTypes";

const TextFieldStyled = styled(TextField)({
  width: "100%",
});

const Button = styled(MuiButton)({
  padding: "12px 24px 12px 24px",
});

const ButtonLabel: FC<{ isSubmitting: boolean; buttonText?: string }> = ({ isSubmitting, buttonText = "Save" }) => {
  if (isSubmitting) {
    return <CircularProgress size="2rem" sx={(theme) => ({ color: theme.palette.text10.main })} />;
  }
  return (
    <Typography variant="button.large" sx={{ color: "text10.main" }}>
      {buttonText}
    </Typography>
  );
};
interface IFormSubmitButton {
  isSubmitting: boolean;
  loading: boolean;
  isValid: boolean;
  buttonType: EditorButtonType;
  buttonText?: string;
  endIcon?: React.ReactNode;
  sx?: SxProps;
  mode?: string;
}
const FormSubmitButton: FC<IFormSubmitButton> = ({
  isSubmitting,
  loading,
  isValid,
  buttonType,
  buttonText,
  endIcon,
  sx,
  mode,
}) => {
  const actualButtonType = mode === "edit" ? "default" : buttonType;

  switch (actualButtonType) {
    case "google":
      return <GoogleOauthButton id={"saveKey"} isSubmitting={isSubmitting || loading} isValid={isValid} />;

    case "youtube":
      return (
        <FormComponent.SubmitButtonYoutube id={"saveKey"} isSubmitting={isSubmitting || loading} isValid={isValid} />
      );

    case "facebook":
      return <FacebookOauthButton id={"saveKey"} isSubmitting={isSubmitting || loading} isValid={isValid} />;
    default:
      return (
        <Button
          type="submit"
          color="secondary"
          disabled={!isValid || loading}
          id="saveKey"
          data-testid="submit-button"
          endIcon={endIcon}
          sx={sx}
        >
          <ButtonLabel buttonText={buttonText} isSubmitting={isSubmitting || loading} />
        </Button>
      );
  }
};

export { Button, FormSubmitButton, TextFieldStyled };
